module.exports = __webpack_public_path__ + "static/media/text.27201e07.svg";